import { fetchPatientCard } from '../services/patientCard';
import { PATIENT_CARD_KEY } from './queryKeys';

export function patientCardQuery(patientId: string) {
    return {
        queryKey: PATIENT_CARD_KEY(patientId),
        queryFn: () => fetchPatientCard(patientId)
    };
}
